import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";

import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import EditProfile from "./pages/editProfile/EditProfile";
import Profile from "./pages/profile/Profile";
import AdminPanel from "./pages/AdminPanel/AdminPanel";
import EmailTester from "./pages/EmailTester/EmailTester";
import Rewards from "./components/rewards/Rewards";
import Loading from "./components/Loading/Loading";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";

import "./style/dark.scss";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const { currentUser, loading } = useContext(AuthContext);

  if (loading) {
    return <Loading fullScreen />;
  }

  const AuthRoute = ({ children }) => {
    if (!currentUser) {
      return <Navigate to="/login" />;
    }
    return children;
  };

  // El panel de administración y sus herramientas solo son visibles para
  // usuarios con rol admin (el backend ya lo exige; esto evita que un
  // usuario normal aterrice en una pantalla llena de errores 403).
  const AdminRoute = ({ children }) => {
    if (!currentUser) {
      return <Navigate to="/login" />;
    }
    if (currentUser.rol !== "admin") {
      return <Navigate to="/" />;
    }
    return children;
  };

  const router = createBrowserRouter([
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/",
      element: (
        <AuthRoute>
          <Home />
        </AuthRoute>
      ),
    },
    {
      path: "/space/:spaceId",
      element: (
        <AuthRoute>
          <Home />
        </AuthRoute>
      ),
    },
    {
      path: "/profile/:username",
      element: (
        <AuthRoute>
          <Profile />
        </AuthRoute>
      ),
    },
    {
      path: "/profile/:username/edit",
      element: (
        <AuthRoute>
          <EditProfile />
        </AuthRoute>
      ),
    },
    {
      path: "/admin",
      element: (
        <AdminRoute>
          <AdminPanel />
        </AdminRoute>
      ),
    },
    {
      path: "/admin/email-tester",
      element: (
        <AdminRoute>
          <EmailTester />
        </AdminRoute>
      ),
    },
    {
      path: "/rewards",
      element: (
        <AuthRoute>
          <Rewards />
        </AuthRoute>
      ),
    },
  ]);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <RouterProvider router={router} />
      {currentUser && <WhatsAppButton />}
    </div>
  );
}

export default App;
